import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import StickyQualifyCTA from "@/components/site/StickyQualifyCTA";
import HomePage from "@/pages/HomePage";
import MeetJeremyPage from "@/pages/MeetJeremyPage";
import HowSolarWorksPage from "@/pages/HowSolarWorksPage";
import WhySolarNowPage from "@/pages/WhySolarNowPage";
import HomeownerQuestionsPage from "@/pages/HomeownerQuestionsPage";
import WhyIONPage from "@/pages/WhyIONPage";
import QualifyPage from "@/pages/QualifyPage";
import ThankYouPage from "@/pages/ThankYouPage";
import CustomerLoginPage from "@/pages/CustomerLoginPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/meet-jeremy" element={<MeetJeremyPage />} />
          <Route path="/how-solar-works" element={<HowSolarWorksPage />} />
          <Route path="/how-ppa-works" element={<HowSolarWorksPage />} />
          <Route path="/why-solar-now" element={<WhySolarNowPage />} />
          <Route path="/homeowner-questions" element={<HomeownerQuestionsPage />} />
          <Route path="/your-protection" element={<HomeownerQuestionsPage />} />
          <Route path="/why-ion" element={<WhyIONPage />} />
          <Route path="/about" element={<WhyIONPage />} />
          <Route path="/qualify" element={<QualifyPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/customer-login" element={<CustomerLoginPage />} />
        </Routes>
        <Footer />
        <StickyQualifyCTA />
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
